import React from 'react';

import {
  ItemName,
  StyledInput,
  StyledSelect,
  TransformNameBuilderContainer,
  TransformNameBuilderItem,
  TransformNameBuilderTitle,
  TransformNameWrapper,
} from '@components/data-transform-panel/components/TransformNameBuilder/styled';
import { ITransformNameBuilder } from '@components/data-transform-panel/components/TransformNameBuilder/typed';
import { ERenamedDimension } from '@src/common/constant/enum';

const TransformNameBuilder: React.FC<ITransformNameBuilder> = ({
  name,
  targetDimension,
  onInputChange,
}) => {
  const options = [
    { value: ERenamedDimension.edited_page_title, label: 'Edited Page Title' },
    { value: ERenamedDimension.edited_screen_title, label: 'Edited Screen Title' },
  ];

  return (
    <TransformNameWrapper>
      <TransformNameBuilderTitle>Transform To:</TransformNameBuilderTitle>
      <TransformNameBuilderContainer>
        <TransformNameBuilderItem>
          <ItemName>Set New Name *</ItemName>
          <StyledInput
            placeholder="Please input..."
            allowClear
            value={name}
            onChange={onInputChange}
          />
        </TransformNameBuilderItem>
        <TransformNameBuilderItem>
          <ItemName>Save to Dimension *</ItemName>
          <StyledSelect
            disabled
            placeholder="Please select..."
            value={targetDimension}
            options={options}
          />
        </TransformNameBuilderItem>
      </TransformNameBuilderContainer>
    </TransformNameWrapper>
  );
};

export default TransformNameBuilder;
